import React, { useState } from "react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Plus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import * as Lucide from "lucide-react";
import { useCanvasId } from "@/utils/utils";
interface ActionDropdownProps {
  value: string;
  onChange: (value: string) => void;
  handleAddContext: () => void;
  shouldShowFileUpload: boolean;
  FileUploadComponent?: React.ComponentType<{
    className?: string;
    fileUploadCallback?: () => void;
    buttonLabel?: React.ReactNode;
  }>;
  FileUploadToCodebaseComponent?: React.ComponentType<{
    canvasId: string;
    codebaseDirectory?: string;
    onUploadSuccess?: (file: any) => void;
    className?: string;
    buttonLabel?: React.ReactNode;
    fileUploadCallback?: () => void;
  }>;
}

const ActionDropdown: React.FC<ActionDropdownProps> = ({
  value,
  shouldShowFileUpload,
  handleAddContext,
  FileUploadComponent,
  FileUploadToCodebaseComponent,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const canvasId = useCanvasId();
  return (
    <DropdownMenu open={isOpen} onOpenChange={(open) => setIsOpen(open)}>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          className={cn(
            "h-7 w-7 p-1 rounded-md transition-colors bg-secondary-n-950",
          )}
        >
          <Plus
            className={cn(
              "h-4 w-4 transition-colors",
              isOpen ? "text-secondary-n-50" : "text-icons-secondary",
            )}
          />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="start"
        className="max-w-72 rounded-lg p-2 gap-y-1 flex flex-col"
        side={"top"}
      >
        {shouldShowFileUpload && (
          <>
            {FileUploadComponent && (
              <FileUploadComponent
                fileUploadCallback={() => setIsOpen(false)}
              />
            )}
            {canvasId && FileUploadToCodebaseComponent && (
              <FileUploadToCodebaseComponent
                canvasId={canvasId}
                fileUploadCallback={() => setIsOpen(false)}
              />
            )}
          </>
        )}

        <DropdownMenuItem
          className="text-xs flex items-center gap-2 cursor-pointer group"
          onSelect={() => handleAddContext()}
        >
          <Lucide.SquareMousePointer className="cursor-pointer size-4 text-icons-muted group-hover:text-icons-primary outline-hidden" />
          Pick and add context
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default ActionDropdown;
